import React, { useState, useEffect } from "react";

const CustomPagination = ({ totalPages, currentPage, handlePageChange }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [pageBlock, setPageBlock] = useState(0);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const pagesPerBlock = isMobile ? 5 : 10;
  const startPage = pageBlock * pagesPerBlock + 1;
  const endPage = Math.min(startPage + pagesPerBlock - 1, totalPages);

  const onPageClick = (page) => {
    handlePageChange({ selected: page - 1 });
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageClick(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageClick(currentPage - 1);
    }
  };

  useEffect(() => {
    const currentBlock = Math.floor((currentPage - 1) / pagesPerBlock);
    setPageBlock(currentBlock);
  }, [currentPage, pagesPerBlock]);

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="pagination-section">
      {/* First Page */}
      <button
        className="pagination-first-button"
        onClick={() => onPageClick(1)}
        disabled={currentPage === 1}
      >
        &lt;&lt;
      </button>

      {/* Pagination container includes prev, pages, next */}
      <ul className="pagination-container">
        {/* Prev Page */}
        <li className="pagination-nav">
          <button
            className="pagination-nav-link"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            &lt;
          </button>
        </li>

        {/* Page Numbers */}
        {pageNumbers.map((num) => (
          <li
            key={num}
            className={`pagination-page ${
              currentPage === num ? "pagination-active" : ""
            }`}
          >
            <button
              className="pagination-link"
              onClick={() => onPageClick(num)}
            >
              {num}
            </button>
          </li>
        ))}

        {/* Next Page */}
        <li className="pagination-nav">
          <button
            className="pagination-nav-link"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
        </li>
      </ul>

      {/* Last Page */}
      <button
        className="pagination-last-button"
        onClick={() => onPageClick(totalPages)}
        disabled={currentPage === totalPages}
      >
        &gt;&gt;
      </button>
    </div>
  );
};

export default CustomPagination;
